import React from 'react';
import SEO from '../components/SEO/SEO';
import SiteDescription from '../components/SiteDescription';

const About: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About travelbaba786',
    url: 'https://travelbaba786.com/about',
    description:
      'TravelBaba786 is a recognised one-stop shop for official government E-Visa, ETA, and digital entry gateways globally.',
    mainEntity: {
      '@type': 'Organization',
      name: 'travelbaba786',
      url: 'https://travelbaba786.com',
      description:
        'An independent directory providing verified links to official government websites for visa applications and travel documentation.',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@travelersapi.com',
        contactType: 'Customer Service',
      },
    },
  };

  return (
    <>
      <SEO
        title="About travelbaba786 - Verified Directory for Official Government Visa Portals"
        description="At TravelBaba786, we provide a recognised one-stop shop for official government E-Visa, ETA, and digital entry gateways globally."
        keywords="about travelers api, verified visa directory, official government portals, e-visa directory, travel information directory, visa application help"
        url="https://travelbaba786.com/about"
        type="article"
        structuredData={structuredData}
      />
      <div className="max-w-7xl mx-auto">
        <SiteDescription />
      </div>
    </>
  );
};

export default About;

